export const WalletConnectV2Create = () => {
  return (
    <>
      <p>Add new connection</p>
    </>
  )
}
